export default "__VITE_ASSET__CUufKfKF__"